import React, { useEffect, useState } from "react";
import SummaryApi from "../common";
import { useNavigate } from "react-router-dom";
import img1 from "../Assets/Slide3/COURSES.png";
import img2 from "../Assets/Slide3/BESTFACULTY.png";
import img3 from "../Assets/Slide3/ENVIRONMENT.png";
import img4 from "../Assets/aff.png";

const Cards = () => {
  const [events, setEvents] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    fetch(SummaryApi.getevents.url, {
      method: "get",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((data) => {
        // console.log("Fetched data:", data);
        const filteredEvents = data.data.filter(
          (event) => event.category_name === "Campus"
        );
        // console.log("Filtered Campus Events:", filteredEvents);
        setEvents(filteredEvents);
      })
      .catch((error) => {
        console.error("Error fetching events:", error);
      });
  }, []);

  const handleEventClick = (event) => {
    navigate("/events-screen", {
      state: {
        eventDetails: event, // Passing the event data to the next screen
        allEvents: events, // Passing all the events
      },
    });
  };

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8 p-6">
    <a href="/courses">
      <div className="card transition-all duration-300 transform hover:scale-105 hover:shadow-xl">
        <img
          className="w-full h-48 object-cover rounded-t-lg"
          src={img1}
          alt="Card 1"
        />
        <div className="p-4 bg-white rounded-b-lg shadow-lg flex items-center justify-center">
          <h3 className="text-lg font-semibold text-center text-[#005E8A] relative inline-block group">
            Courses
            <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-[#005E8A] transition-all duration-300 group-hover:w-full"></span>
          </h3>
        </div>
      </div>
    </a>
  
    <a href="/MeetFaculty">
      <div className="card transition-all duration-300 transform hover:scale-105 hover:shadow-xl">
        <img
          className="w-full h-48 object-cover rounded-t-lg"
          src={img2}
          alt="Card 2"
        />
        <div className="p-4 bg-white rounded-b-lg shadow-lg flex items-center justify-center">
          <h3 className="text-lg font-semibold text-center text-[#005E8A] relative inline-block group">
            Best Faculty
            <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-[#005E8A] transition-all duration-300 group-hover:w-full"></span>
          </h3>
        </div>
      </div>
    </a>
  
    <div
      className="card transition-all duration-300 transform hover:scale-105 hover:shadow-xl"
      onClick={() => handleEventClick(events[0])}
      style={{ cursor: "pointer" }}
    >
      <img
        className="w-full h-48 object-cover rounded-t-lg"
        src={img3}
        alt="Card 3"
      />
      <div className="p-4 bg-white rounded-b-lg shadow-lg flex items-center justify-center">
        <h3 className="text-lg font-semibold text-center text-[#005E8A] relative inline-block group">
          Good Environment
          <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-[#005E8A] transition-all duration-300 group-hover:w-full"></span>
        </h3>
      </div>
    </div>
  
    <div className="card transition-all duration-300 transform hover:scale-105 hover:shadow-xl">
      <img
        className="w-full h-48 object-cover rounded-t-lg"
        src={img4}
        alt="Card 4"
      />
      <div className="p-4 bg-white rounded-b-lg shadow-lg flex justify-between ">
        <div className=" flex justify-between w-[80%] mx-auto">
        <a href="/Certificate" className="text-center">
          <h3 className="text-lg font-semibold text-center text-[#005E8A] relative inline-block group ">
            Affiliations
            <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-[#005E8A] transition-all duration-300 group-hover:w-full"></span>
          </h3>
        </a>
        <a href="/approvals">
          <h3 className="text-lg font-semibold text-center text-[#005E8A] relative inline-block group ">
            Approvals
            <span className="absolute bottom-0 left-0 w-0 h-0.5  bg-[#005E8A] transition-all duration-300 group-hover:w-full"></span>
          </h3>
        </a>
        </div>
      
      </div>
    </div>
  </div>
  
  
  );
};

export default Cards;
